import React from 'react'
import PropTypes from 'prop-types'
import { cx } from '@emotion/css'
import { Button, SubmitButton } from '@offerzen/pinata-shame'

import styles from './styles'

const CardFooterNav = ({ navigateBack, loading, theme = 'primary', submitLabel = 'Next', className, submitDisabled = false }) => (
  <div className={cx(styles.footer, className)}>
    <If condition={!!navigateBack}>
      <Button variant="outlined" theme="light" size="medium" onClick={navigateBack} label="Back" />
    </If>

    <SubmitButton
      label={submitLabel}
      submittingLabel="Loading"
      isSubmitting={loading}
      theme={theme}
      className={styles.button}
      disabled={submitDisabled}
    />
  </div>
)

CardFooterNav.propTypes = {
  navigateBack: PropTypes.func,
  loading: PropTypes.bool,
  theme: PropTypes.oneOf(['', 'primary', 'secondary', 'success', 'warning', 'error', 'legacy', 'light', 'dark', 'tertiary', 'info']),
  className: PropTypes.string,
  submitLabel: PropTypes.string,
  submitDisabled: PropTypes.bool,
}

export default CardFooterNav
